export default __webpack_public_path__ + "static/media/React.428839d4.png";